import React, {Component} from 'react';
import {List, Picker,Toast,NavBar,InputItem} from 'antd-mobile';
import {orderDetail} from "../../../service/rentService";
import './index.less';
import {connect} from "react-redux";
@connect(
    state => ({userInfo: state.userInfo}),
)
export default class RentDetail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            orderData:{}
        };
    }

    componentDidMount() {
        this.rentDetail();
    }
    rentDetail = () =>{
        let params = {
            token: this.props.userInfo.token,
            "data":{
                "id":this.props.location.state.id,
            }
        };
        orderDetail(params)
            .then((res) => {
                console.log(res)
                if (res.data.code === '0000') {
                    this.setState({
                        orderData:res.data.data
                    })
                   
                 }
                 else if (res.data.code === '1401') {
                    document.location = `js://toLogin?token=${this.props.userInfo.token}`;
                 }
                 else {
                     Toast.info(res.data.msg);
                 }
            }).catch(function (error) {
        });
    }
    status = (params) =>{
        if(params === 0){
            return "待审核"
        }
        if(params === 1){
            return "待付款"
        }
        if(params === 2){
            return "待出行"
        }
        if(params === 3){
            return "行程中"
        }
        if(params === 4){
            return "已完成"
        }
        if(params === 99){
            return "已取消"
        }
    }
    render() {
        const data = this.state.orderData;
        return (
            <div className="RentDetail">
                <NavBar
                    className="navBar"
                    mode="light"
                    icon={<i className="icon iconfont iconmorenfanhui"  onClick={() => this.props.history.goBack()}/>}
                >订单详情</NavBar>
                <div className="content">
                    <div className="rentType"><span>专车预约类型</span><span>{data.orderGenre === 0 ? "单程包车" : (data.orderGenre === 1 ? "往返包车" : "按天包车")}</span></div>
                    <div className="rentType"><span>出发城市</span><span>{data.startCity}</span></div>
                    <div className="rentType"><span>目标城市</span><span>{data.endCity}</span></div>
                    <div className="rentType"><span>用车时间</span><span>{data.departTime}</span></div>
                    {data.status == 4 ? null : <div className="rentType"><span>联系电话</span><span>{data.phone}</span></div>}
                    <div className="rentType"><span>专车预约人数</span><span>{data.passengerNum}</span></div>
                    <div className="rentType"><span>价&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;格</span><span>{data.price}</span></div>
                    <div className="rentType"><span>指派司机</span><span>{data.driverName}</span></div>
                    <div className="rentType"><span>指派车辆</span><span>{data.carNum}</span></div>
                    <div className="rentType"><span>备注信息</span><span>{data.description}</span></div>
                    <div className="rentType"><span>状&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;态</span><span>{this.status(data.status)}</span></div>
                </div>
              {/*   <div className="btn">确认订单</div> */}
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/container/RentModule/RentDetail/index.js